const actions = {
  GET_LOGS_REQUEST: "GET_LOGS_REQUEST",
  GET_LOGS_SUCCESS: "GET_LOGS_SUCCESS",

  getLogsRequest: (startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_LOGS_REQUEST,
        startDate,
        endDate,
      });
    };
  },
};

export default actions;
